
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSleetShowersNight as ObiLightSleetShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-sleet-showers-night.js';
 
 
 

 
 export const ObiLightSleetShowersNight = createComponent({
   react: React,
   tagName: 'obi-light-sleet-showers-night',
   elementClass: ObiLightSleetShowersNightElement,
   events: {
     
   }
  });
 
 